/*
 * @Author: Yolo
 * @Date: 2024-03-28 13:54:58
 * @Last Modified by: Yolo
 * @Last Modified time: 2024-06-06 10:23:31
 * @Desc 绘制台风图例
 */
import L from 'leaflet'

type TyphoonLegendOptions = L.ControlOptions

class TyphoonLegendControl extends L.Control {
  private _container!: HTMLElement
  private _legend!: HTMLElement
  private _part1!: HTMLElement
  private _canvas!: HTMLCanvasElement
  private _strong!: HTMLElement
  private _btn_expand!: any

  constructor(options?: TyphoonLegendOptions) {
    super(options)
    this.options.position = 'topright'
  }

  override onAdd() {
    this._container = L.DomUtil.create('div')
    L.DomEvent.disableClickPropagation(this._container)

    this._legend = L.DomUtil.create(
      'div',
      'weather-typh-legend',
      this._container
    )
    this._legend.id = 'weather-typh-legend'

    this._part1 = L.DomUtil.create('div', 'typh-title', this._legend)
    this._canvas = L.DomUtil.create('canvas', '', this._legend)
    this._canvas.id = 'lineCanvas_1'
    this._canvas.width = 180
    this._canvas.height = 370

    this._strong = L.DomUtil.create('div', 'title-txt', this._part1)
    this._strong.textContent = '台风图例'

    this._btn_expand = L.DomUtil.create(
      'div',
      'title-btn btn-right',
      this._part1
    ) as any
    this._btn_expand.id = 'weather-typh-legend-button2'
    this._btn_expand.name = 'a'
    this._btn_expand.textContent = ''

    return this._container
  }

  show(isShow = true) {
    const weatherTyphLegendDom = document.querySelector(
      '#weather-typh-legend'
    ) as HTMLElement
    if (weatherTyphLegendDom) {
      L.DomUtil.removeClass(weatherTyphLegendDom, 'weather-typh-legend-hid')
      L.DomUtil.removeClass(weatherTyphLegendDom, 'weather-typh-legend-block')
      isShow
        ? L.DomUtil.addClass(weatherTyphLegendDom, 'weather-typh-legend-block')
        : L.DomUtil.addClass(weatherTyphLegendDom, 'weather-typh-legend-hid')
    }
  }

  override addTo(datas: any) {
    super.addTo(datas)
    L.DomUtil.addClass(this._container, 'leaflet-control-left')

    const drawCanvasWind = (styleType: 'a' | 'b') => {
      const lineCanvas1 = document.querySelector(
        '#lineCanvas_1'
      ) as HTMLCanvasElement
      const canvas1 = lineCanvas1.getContext('2d') as CanvasRenderingContext2D

      const windSpeed = [
        '10.8~17.1',
        '17.2~24.4',
        '24.5~32.6',
        '32.7~41.4',
        '41.5~50.9',
        '≥51',
      ]
      const windForce = ['6~7', '8~9', '10~11', '12~13', '14~15', '≥16']
      const colors = [
        '#076DEB',
        '#FEF301',
        '#FC8F2B',
        '#FE0405',
        '#FE3BA3',
        '#AD00D8',
      ]
      const windNames = [
        '热带低压',
        '热带风暴',
        '强热带风暴',
        '台风',
        '强台风',
        '超强台风',
        '七级风圈',
        '十级风圈',
        '实际路径',
        '预测路径',
        '24小时警戒线',
        '48小时警戒线',
      ]

      let height = 10
      let additionalOffset = 0

      if (styleType === 'b') {
        lineCanvas1.width = 310
        lineCanvas1.height = 440
        canvas1.strokeStyle = '#000'
        canvas1.lineWidth = 0.5
        canvas1.strokeRect(4, 0, lineCanvas1.width - 8, 204)
        additionalOffset = 5
      } else {
        lineCanvas1.width = 180
        lineCanvas1.height = 400
        additionalOffset = 0
      }

      //绘制台风强度图例
      for (const [i, windName] of windNames.entries()) {
        canvas1.save()
        if (i < 6) {
          if ('b' == styleType) {
            canvas1.beginPath()
            if (0 == i) {
              canvas1.fillStyle = '#000000'
              canvas1.font = '12px Arial'
              canvas1.fillText('级', 20 + additionalOffset, height + 5 + 0)
              canvas1.fillText(
                '风速' + '(' + '米' + '/' + '秒' + ')',
                150 + additionalOffset,
                height + 5 + 0
              )
              canvas1.fillText(
                '风力' + '(' + '级' + '',
                246 + additionalOffset,
                height + 5 + 0
              )
              height += 30
            }
            canvas1.font = '12px Arial'
            canvas1.fillText(windName, 28 + additionalOffset, height + 5 + 0)
            canvas1.fillText(
              windSpeed[i],
              160 + additionalOffset,
              height + 5 + 0
            )
            canvas1.fillText(
              windForce[i],
              240 + additionalOffset,
              height + 5 + 0
            )
            canvas1.closePath()
            canvas1.restore()
          }
          canvas1.save()
          canvas1.lineWidth = 2
          canvas1.strokeStyle = colors[i]
          canvas1.fillStyle = colors[i]
          canvas1.beginPath()
          canvas1.arc(
            15 + additionalOffset,
            height + 0,
            4.5,
            0,
            2 * Math.PI,
            true
          )
          canvas1.stroke()
          canvas1.fill()
          canvas1.closePath()
          canvas1.restore()
        }
        ;(6 != i && 7 != i) ||
          (canvas1.beginPath(),
          (canvas1.lineWidth = 2),
          (canvas1.strokeStyle = 6 == i ? '#D8D243' : '#E59851'),
          canvas1.arc(
            15 + additionalOffset,
            height + 0,
            4.5,
            0,
            2 * Math.PI,
            true
          ),
          canvas1.stroke(),
          canvas1.closePath(),
          canvas1.restore())
        ;(8 != i && 9 != i) ||
          (canvas1.beginPath(),
          (canvas1.fillStyle = '#FE3BA3'),
          (canvas1.strokeStyle = '#FE3BA3'),
          (canvas1.lineWidth = 1.5),
          canvas1.arc(
            13 + additionalOffset,
            height + 0,
            3.5,
            0,
            2 * Math.PI,
            true
          ),
          canvas1.fill(),
          canvas1.stroke(),
          canvas1.closePath(),
          canvas1.beginPath(),
          canvas1.moveTo(17 + additionalOffset, height + 0),
          (canvas1.lineWidth = 3.5),
          (canvas1.strokeStyle = '#FE3BA3'),
          8 == i ||
            (canvas1.lineTo(24.5 + additionalOffset, height + 0),
            canvas1.moveTo(27.5 + additionalOffset, height + 0)),
          canvas1.lineTo(0x24 + additionalOffset, height + 0),
          canvas1.stroke(),
          (canvas1.strokeStyle = '#FE3BA3'),
          (canvas1.lineWidth = 1.5),
          canvas1.closePath(),
          canvas1.beginPath(),
          canvas1.arc(
            39.5 + additionalOffset,
            height + 0,
            3.5,
            0,
            2 * Math.PI,
            true
          ),
          canvas1.fill(),
          canvas1.stroke(),
          canvas1.closePath(),
          canvas1.restore())
        ;(10 != i && 11 != i) ||
          (canvas1.beginPath(),
          (canvas1.strokeStyle = '#BE621F'),
          (canvas1.lineWidth = 2),
          (canvas1.lineCap = 'round'),
          10 == i
            ? (canvas1.moveTo(10 + additionalOffset, height + 0),
              canvas1.lineTo(42 + additionalOffset, height + 0))
            : (canvas1.setLineDash([5, 5]),
              canvas1.moveTo(10 + additionalOffset, height + 0),
              canvas1.lineTo(42 + additionalOffset, height + 0)),
          canvas1.stroke(),
          canvas1.closePath(),
          canvas1.restore())
        if ('a' == styleType || i > 5) {
          canvas1.fillStyle = '#000000'
          canvas1.font = '12px Arial'
          canvas1.beginPath()
          canvas1.fillText(
            windName,
            i <= 7 ? 28 + additionalOffset : 50 + additionalOffset,
            height + 5 + 0
          )
          canvas1.stroke()
          canvas1.closePath()
          canvas1.restore()
        }
        height += 30
      }
    }

    drawCanvasWind('a')

    this._btn_expand.addEventListener('click', () => {
      const weatherTyphLegendButton2 = document.querySelector(
        '#weather-typh-legend-button2'
      ) as any
      const weatherTyphLegend = document.querySelector(
        '#weather-typh-legend'
      ) as HTMLDivElement

      L.DomUtil.removeClass(weatherTyphLegendButton2, 'btn-left')
      L.DomUtil.removeClass(weatherTyphLegendButton2, 'btn-right')

      if (weatherTyphLegendButton2.name === 'a') {
        weatherTyphLegendButton2.name = 'b'
        L.DomUtil.addClass(weatherTyphLegendButton2, 'btn-left')
        weatherTyphLegend.style.width = '310px'
        weatherTyphLegend.style.height = '440px'
        drawCanvasWind('b')
      } else {
        weatherTyphLegendButton2.name = 'a'
        L.DomUtil.addClass(weatherTyphLegendButton2, 'btn-right')
        weatherTyphLegend.style.width = '180px'
        weatherTyphLegend.style.height = '400px'
        drawCanvasWind('a')
      }
    })

    return this
  }
}

const typhoonLegendImpl = (options?: TyphoonLegendOptions | undefined) =>
  new TyphoonLegendControl(options)
export { TyphoonLegendControl, typhoonLegendImpl }
